// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type
// export interface EquipmentIncidentFormData {
//   id?: string;
//   date: string;
//   time: string;
//   location: string;
//   incident_type: string;
//   description: string;
//   damage_or_injury: string;
//   was_injury: string;
//   immediate_actions: string;
//   maintenance_requested: string;
//   reporter_name: string;
//   signature: string;
//   date_completed: string;
//   photo?: File|string;
//   client_email?: string;
// }

// // Define the state type
// export interface EquipmentIncidentState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: EquipmentIncidentState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// // Async thunk for posting equipment incident data
// export const submitEquipmentIncident = createAsyncThunk<
//   { message: string },
//   EquipmentIncidentFormData,
//   { rejectValue: string }
// >('equipmentIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }


//     const payload = {
//       id: formData.id,
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date,
//       time: formData.time,
//       location: formData.location,
//       incident_type: formData.incident_type,
//       description: formData.description,
//       damage_or_injury: formData.damage_or_injury,
//       was_injury: formData.was_injury,
//       immediate_actions: formData.immediate_actions,
//       maintenance_requested: formData.maintenance_requested,
//       reporter_name: formData.reporter_name,
//       signature: formData.signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post(
//       '/ndis/form/equipment-property-vehicle-incident',
//       payload,
//       {
//         headers: { 'Content-Type': 'application/json' }
//       }
//     );
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(
//       error.response?.data?.message || 'Failed to submit equipment incident report'
//     );
//   }
// });

// const equipmentIncidentSlice = createSlice({
//   name: 'equipmentIncident',
//   initialState,
//   reducers: {
//     clearEquipmentIncidentState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitEquipmentIncident.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitEquipmentIncident.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Equipment incident reported successfully';
//         state.error = null;
//       })
//       .addCase(submitEquipmentIncident.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearEquipmentIncidentState } = equipmentIncidentSlice.actions;
// export default equipmentIncidentSlice.reducer;



import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type
export interface EquipmentIncidentFormData {
  id?: string;
  date: string;
  time: string;
  location: string;
  incident_type: string;
  description: string;
  damage_or_injury: string;
  was_injury: string;
  immediate_actions: string;
  maintenance_requested: string;
  resolved?: string; // Added resolved
  reporter_name: string;
  signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
}

// Define the state type
export interface EquipmentIncidentState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: EquipmentIncidentState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for posting equipment incident data
export const submitEquipmentIncident = createAsyncThunk<
  { message: string },
  EquipmentIncidentFormData,
  { rejectValue: string }
>('equipmentIncident/submit', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    const payload = {
      id: formData.id,
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date,
      time: formData.time,
      location: formData.location,
      incident_type: formData.incident_type,
      description: formData.description,
      damage_or_injury: formData.damage_or_injury,
      was_injury: formData.was_injury,
      immediate_actions: formData.immediate_actions,
      maintenance_requested: formData.maintenance_requested,
      resolved: formData.resolved, // Added resolved
      reporter_name: formData.reporter_name,
      signature: formData.signature,
      date_completed: formData.date_completed,
      photo: photoField
    };

    const response = await axiosInstance.post(
      '/ndis/form/equipment-property-vehicle-incident',
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error.response?.data?.message || 'Failed to submit equipment incident report'
    );
  }
});

const equipmentIncidentSlice = createSlice({
  name: 'equipmentIncident',
  initialState,
  reducers: {
    clearEquipmentIncidentState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitEquipmentIncident.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitEquipmentIncident.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Equipment incident reported successfully';
        state.error = null;
      })
      .addCase(submitEquipmentIncident.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearEquipmentIncidentState } = equipmentIncidentSlice.actions;
export default equipmentIncidentSlice.reducer;
